export default "<app-chart \n  chartType=\"pie\" \n  [chartData]=\"pieChartData\" \n  [chartLabels]=\"pieChartLabels\"\n>\n</app-chart>\n\n";